import AccountDepositPaymentOrderSettings from "@/models/Accounts/DepositAccounts/Settings/AccountDepositPaymentOrderSettings";
import BaseUpdateAccountSettings from "@/models/Accounts/Shared/BaseUpdateAccountSettings";
import Amount from "@/models/Shared/Amount";
import PeriodType from "@/models/Shared/PeriodType";

export default class UpdateAccountDepositPaymentOrderSettingsRequest extends BaseUpdateAccountSettings {
    oneApprovalThresholdEnabled: boolean = false;
    twoApprovalThresholdEnabled: boolean = false;
    threeApprovalThresholdEnabled: boolean = false;
    oneApprovalThreshold: Amount = new Amount();
    twoApprovalThreshold: Amount = new Amount();
    threeApprovalThreshold: Amount = new Amount();
    noticePeriodEnabled: boolean = false;
    noticePeriodType: PeriodType;
    noticePeriodValue: number;
    restrictToWorkingDay: boolean = false;

    public constructor(settings: AccountDepositPaymentOrderSettings, updatedAt: Date) {
        super(updatedAt);
        if (settings !== null) {
            this.oneApprovalThresholdEnabled = settings.oneApprovalThresholdEnabled;
            this.twoApprovalThresholdEnabled = settings.twoApprovalThresholdEnabled;
            this.threeApprovalThresholdEnabled = settings.threeApprovalThresholdEnabled;
            this.oneApprovalThreshold = settings.oneApprovalThreshold;
            this.twoApprovalThreshold = settings.twoApprovalThreshold;
            this.threeApprovalThreshold = settings.threeApprovalThreshold;
            this.noticePeriodEnabled = settings.noticePeriodEnabled;
            if (this.noticePeriodEnabled) {
                this.noticePeriodType = settings.noticePeriodType;
                this.noticePeriodValue = settings.noticePeriodValue;
                this.noticePeriodValue = +this.noticePeriodValue;
                this.restrictToWorkingDay = settings.restrictToWorkingDay;
            }
        }
    }
}